// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var msPerDay = 24 * 60 * 60 * 1000;

var isoDateRe = new RegExp("^(\\d{4})-(\\d{2})-(\\d{2})$");

function parseIsoDateLocal(ymd) {
  var captures = ymd.match(isoDateRe);
  if (captures === null) {
    return ;
  }
  var match = Belt_Array.get(captures, 1);
  var match$1 = Belt_Array.get(captures, 2);
  var match$2 = Belt_Array.get(captures, 3);
  if (match === undefined) {
    return ;
  }
  var ys = Caml_option.valFromOption(match);
  if (ys === undefined) {
    return ;
  }
  if (match$1 === undefined) {
    return ;
  }
  var ms = Caml_option.valFromOption(match$1);
  if (ms === undefined) {
    return ;
  }
  if (match$2 === undefined) {
    return ;
  }
  var ds = Caml_option.valFromOption(match$2);
  if (ds === undefined) {
    return ;
  }
  var match$3 = Belt_Float.fromString(ys);
  var match$4 = Belt_Float.fromString(ms);
  var match$5 = Belt_Float.fromString(ds);
  if (match$3 !== undefined && match$4 !== undefined && match$5 !== undefined) {
    return Caml_option.some(new Date(match$3, match$4 - 1, match$5, 0, 0, 0));
  }
  
}

function updateTimelineNowLine(scroller) {
  var startIso = DomEl$GameDataCore.data(scroller, "timeline-start");
  var endIso = DomEl$GameDataCore.data(scroller, "timeline-end");
  var dayColRaw = DomEl$GameDataCore.data(scroller, "day-col-rem");
  if (startIso === "" || endIso === "") {
    return ;
  }
  var dayColRem = Belt_Float.fromString(dayColRaw);
  if (dayColRem === undefined) {
    return ;
  }
  if (!(dayColRem > 0 && Number.isFinite(dayColRem))) {
    return ;
  }
  var match = parseIsoDateLocal(startIso);
  var match$1 = parseIsoDateLocal(endIso);
  if (match === undefined) {
    return ;
  }
  if (match$1 === undefined) {
    return ;
  }
  var start = Caml_option.valFromOption(match);
  var now = new Date();
  var dayOffset = (now.getTime() - start.getTime()) / msPerDay;
  var endOffset = (Caml_option.valFromOption(match$1).getTime() - start.getTime()) / msPerDay + 1;
  var lines = Array.from(scroller.querySelectorAll(".timeline-now-line"));
  if (lines.length === 0) {
    return ;
  }
  if (dayOffset < 0 || dayOffset > endOffset) {
    return Belt_Array.forEach(lines, (function (line) {
                  line.style.display = "none";
                }));
  }
  var leftRem = dayOffset * dayColRem;
  var leftCss = String(leftRem) + "rem";
  Belt_Array.forEach(lines, (function (line) {
          var style = line.style;
          style.display = "";
          style.left = leftCss;
        }));
}

function scrollTimelineToDate(scroller, date) {
  var target = document.getElementById("timeline-day-" + date);
  if (!(target == null)) {
    requestAnimationFrame(function () {
          var targetLeft = target.offsetLeft;
          var targetCenter = targetLeft + target.clientWidth / 2;
          var nextLeft = Math.max(0, targetCenter - scroller.clientWidth / 2);
          scroller.scrollTo({
                left: nextLeft,
                behavior: "smooth"
              });
          updateTimelineNowLine(scroller);
        });
    return ;
  }
  
}

function mounted() {
  var self = this ;
  var onResize = function (_event) {
    updateTimelineNowLine(self.el);
  };
  self._onResize = onResize;
  window.addEventListener("resize", onResize, {});
  self.handleEvent("timeline-scroll-to-today", (function (payload) {
          var date = payload.date;
          if (date !== undefined && date !== "") {
            return scrollTimelineToDate(self.el, date);
          }
          
        }));
  updateTimelineNowLine(self.el);
}

function updated() {
  var self = this ;
  updateTimelineNowLine(self.el);
}

function destroyed() {
  var self = this ;
  var handler = self._onResize;
  if (handler !== undefined) {
    window.removeEventListener("resize", handler);
  }
  self._onResize = undefined;
}

var CalendarTimeline = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  msPerDay ,
  isoDateRe ,
  parseIsoDateLocal ,
  updateTimelineNowLine ,
  scrollTimelineToDate ,
  mounted ,
  updated ,
  destroyed ,
  CalendarTimeline ,
}
/* isoDateRe Not a pure module */
